import { createReducer, on } from '@ngrx/store';
import { HodDashboardSummaryDto } from '../../../../api/gse/models/hod-dashboard-summary-dto';
import { MaintenanceWeeklyOverviewDto } from '../../../../api/gse/models/maintenance-weekly-overview-dto';
import { TopTechnicianDto } from '../../../../api/gse/models/top-technician-dto';
import { SparePartUtilizationDashboardDto } from '../../../../api/gse/models/spare-part-utilization-dashboard-dto';
import { InventoryCorrectionDto } from 'src/app/api/gse/models/inventory-correction-dto';
import { MaintenanceTatOverviewPointDto } from 'src/app/api/gse/models/maintenance-tat-overview-point-dto';
import * as HodDashboardActions from './hod-dashboard.actions';

export interface HodDashboardState {
  summary: HodDashboardSummaryDto | null;
  loading: boolean;
  error: string | null;
  topTechnicians: TopTechnicianDto[];
  topTechniciansLoading: boolean;
  topTechniciansError: string | null;
  weeklyOverview: MaintenanceWeeklyOverviewDto[];
  weeklyOverviewLoading: boolean;
  weeklyOverviewError: string | null;
  sparePartUtilization: SparePartUtilizationDashboardDto[];
  sparePartUtilizationLoading: boolean;
  sparePartUtilizationError: string | null;
  inventoryCorrections: InventoryCorrectionDto[];
  inventoryCorrectionsLoading: boolean;
  inventoryCorrectionsError: string | null;
  equipmentTatOverview: MaintenanceTatOverviewPointDto[];
  equipmentTatOverviewLoading: boolean;
  equipmentTatOverviewError: string | null;
}

export const initialState: HodDashboardState = {
  summary: null,
  loading: false,
  error: null,
  topTechnicians: [],
  topTechniciansLoading: false,
  topTechniciansError: null,
  weeklyOverview: [],
  weeklyOverviewLoading: false,
  weeklyOverviewError: null,
  sparePartUtilization: [],
  sparePartUtilizationLoading: false,
  sparePartUtilizationError: null,
  inventoryCorrections: [],
  inventoryCorrectionsLoading: false,
  inventoryCorrectionsError: null,
  equipmentTatOverview: [],
  equipmentTatOverviewLoading: false,
  equipmentTatOverviewError: null,
};

export const hodDashboardReducer = createReducer(
  initialState,
  on(HodDashboardActions.loadHodDashboardSummary, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(HodDashboardActions.loadHodDashboardSummarySuccess, (state, { summary }) => ({
    ...state,
    summary,
    loading: false,
  })),
  on(HodDashboardActions.loadHodDashboardSummaryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(HodDashboardActions.loadHodTopTechnicians, (state) => ({
    ...state,
    topTechniciansLoading: true,
    topTechniciansError: null,
  })),
  on(HodDashboardActions.loadHodTopTechniciansSuccess, (state, { topTechnicians }) => ({
    ...state,
    topTechnicians,
    topTechniciansLoading: false,
  })),
  on(HodDashboardActions.loadHodTopTechniciansFailure, (state, { error }) => ({
    ...state,
    topTechniciansLoading: false,
    topTechniciansError: error,
  })),
  on(HodDashboardActions.loadHodMaintenanceWeeklyOverview, (state) => ({
    ...state,
    weeklyOverviewLoading: true,
    weeklyOverviewError: null,
  })),
  on(HodDashboardActions.loadHodMaintenanceWeeklyOverviewSuccess, (state, { weeklyOverview }) => ({
    ...state,
    weeklyOverview,
    weeklyOverviewLoading: false,
  })),
  on(HodDashboardActions.loadHodMaintenanceWeeklyOverviewFailure, (state, { error }) => ({
    ...state,
    weeklyOverviewLoading: false,
    weeklyOverviewError: error,
  })),
  on(HodDashboardActions.loadHodSparePartUtilization, (state) => ({
    ...state,
    sparePartUtilizationLoading: true,
    sparePartUtilizationError: null,
  })),
  on(HodDashboardActions.loadHodSparePartUtilizationSuccess, (state, { utilization }) => ({
    ...state,
    sparePartUtilization: utilization,
    sparePartUtilizationLoading: false,
  })),
  on(HodDashboardActions.loadHodSparePartUtilizationFailure, (state, { error }) => ({
    ...state,
    sparePartUtilizationLoading: false,
    sparePartUtilizationError: error,
  })),
  on(HodDashboardActions.loadHodInventoryCorrections, (state) => ({
    ...state,
    inventoryCorrectionsLoading: true,
    inventoryCorrectionsError: null,
  })),
  on(HodDashboardActions.loadHodInventoryCorrectionsSuccess, (state, { corrections }) => ({
    ...state,
    inventoryCorrections: corrections,
    inventoryCorrectionsLoading: false,
  })),
  on(HodDashboardActions.loadHodInventoryCorrectionsFailure, (state, { error }) => ({
    ...state,
    inventoryCorrectionsLoading: false,
    inventoryCorrectionsError: error,
  })),
  on(HodDashboardActions.loadHodEquipmentTatOverview, (state) => ({
    ...state,
    equipmentTatOverviewLoading: true,
    equipmentTatOverviewError: null,
  })),
  on(HodDashboardActions.loadHodEquipmentTatOverviewSuccess, (state, { tatOverview }) => ({
    ...state,
    equipmentTatOverview: tatOverview,
    equipmentTatOverviewLoading: false,
  })),
  on(HodDashboardActions.loadHodEquipmentTatOverviewFailure, (state, { error }) => ({
    ...state,
    equipmentTatOverviewLoading: false,
    equipmentTatOverviewError: error,
  }))
);
